import axios from 'axios';

// Buat instance Axios
const axiosInstance = axios.create({
  baseURL: 'https://bbpom-makassar.com/api/search-sub', // Ganti dengan URL backend Laravel
  withCredentials: true,           // Agar cookie CSRF terkirim
});

// Middleware untuk menambahkan token CSRF
axiosInstance.interceptors.request.use(async (config) => {
  // Pastikan permintaan hanya untuk method tertentu
  if (['post', 'put', 'delete'].includes(config.method)) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    if (token) {
      config.headers['X-CSRF-TOKEN'] = token;
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default axiosInstance;
